module.exports = __webpack_public_path__ + "media/images/recipes/ossenworst-7a9d039b334a72198607e255566391b2.pdf";